import { 
  getCities, 
  getAreas, 
  getCurrencies,
  getCategories,
  getTenantFilters,
  getStorefrontLookup,
  getStorefrontCurrencyLookup,
  CityQueryParams,
  AreaQueryParams,
  CurrencyQueryParams,
  StorefrontCurrencyQueryParams,
} from '../../shared/lookups';
export const lookupQueries = {
  queries: {
    cities: (params?: CityQueryParams) => ({
      queryKey: ['cities', ...(params ? [params] : [])],
      queryFn: async () => {
        return getCities(params);
      }
    }),
    
    areas: (params?: AreaQueryParams) => ({
      queryKey: ['areas', ...(params ? [params] : [])],
      queryFn: async () => {
        return getAreas(params);
      }
    }),
    
    currencies: (params?: CurrencyQueryParams) => ({
      queryKey: ['currencies', ...(params ? [params] : [])],
      queryFn: async () => {
        return getCurrencies(params);
      }
    }),

    categories: (params?: { storefront_id?: number; tenant_id: number ,component_id?:number}) => ({
      queryKey: ['categories', ...(params ? [params] : [])],
      queryFn: async () => {
        return getCategories(params);
      }
    }),

    tenantFilters: (params?: { tenant_id?: number; component_id?: number, storefront_id?:number}) => ({
      queryKey: ['tenantFilters', ...(params ? [params] : [])],
      queryFn: async () => {
        return getTenantFilters(params);
      }
    }),

    storefront: () => ({
      queryKey: ['storefront-lookup'],
      queryFn: async () => {
        return getStorefrontLookup();
      }
    }),

    storefrontCurrency: (params: StorefrontCurrencyQueryParams) => ({
      queryKey: ['storefront-currency', params],
      queryFn: async () => {
        return getStorefrontCurrencyLookup(params);
      }
    })
  }
};
